import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fc-matrix-cell',
    host: {
        '[class.fc-matrix-cell--disabled]': 'disabled',
        '[class.fc-matrix-header-cell-text]': "type === 'headerText'",
        '[class.fc-matrix-body-cell-text-title]': "type === 'bodyTextTitle'",
        '[class.fc-matrix-body-cell-prepack-title]': "type === 'prepackTextTitle'",
        '[class.fc-matrix-body-cell-text]': "type === 'bodyText'",
        '[class.fc-matrix-body-cell-input]': "type === 'bodyInput'",
        '[class.fc-matrix-body-cell-prepack-input]': "type === 'prepackInput'",
        '[class.fc-matrix-body-cell-prepack]': "type === 'bodyPrepack'",
        '[class.fc-matrix-footer]': 'isFooter',
        class: 'fc-matrix fcp-text fcp-text-body-m'
    },
    templateUrl: './cell.component.html',
    styleUrls: ['./cell.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OrderCellComponent {
    @Input() disabled = false;
    @Input() type: MatrixCellType = MatrixCellType.BodyText;
    @Input() isFooter: boolean;
}

export enum MatrixCellType {
    HeaderText = 'headerText',
    BodyTextTitle = 'bodyTextTitle',
    BodyText = 'bodyText',
    BodyInput = 'bodyInput',
    BodyPrepack = 'bodyPrepack'
}
